module.exports = __webpack_public_path__ + "img/titleicon1.b2b6654a.png";